import React, {useState, useEffect, useCallback, useRef} from 'react';
import SMCTextInput from '../../../components/Simple/SMCTextInput';
import FilterLayout from '../FilterLayout';
import {UserFilterSchema} from '../../../api/DBSchema/User';

function SystemRoleFilterPane({
    initialFilter,
    onFilterChange,
    open
}) {
    const didMountRef = useRef(true);
    const freeTextSearchRef = useRef();

    useEffect(() => {
        if (open && freeTextSearchRef.current) {
            freeTextSearchRef.current.focus();
        }
    }, [open]);

    const [freeTextSearch, setFreeTextSearch] = useState(
        initialFilter.freeTextSearch ? initialFilter.freeTextSearch.value : ''
    );
        
    const resetToDefaults = useCallback(() => {
        setFreeTextSearch('');
    }, []);


    // Update filter request object on value change
    useEffect(() => {
        // Don't run on first render
        if (didMountRef.current === true) {
            didMountRef.current = false;
            return;
        }

        const filterRequestObj = {};
        // Free text search
        if (freeTextSearch) {
            filterRequestObj[UserFilterSchema.freeTextSearch] = { value: freeTextSearch };
        }
        
        onFilterChange(filterRequestObj);
    }, [
        freeTextSearch, onFilterChange
    ]);

    return (
        <FilterLayout clearAllAction={resetToDefaults}>
            <SMCTextInput
                width="auto"
                height={26}
                placeholder="Search"
                value={freeTextSearch}
                innerRef={freeTextSearchRef}
                onChange={e => setFreeTextSearch(e.target.value)}
            />
        </FilterLayout>
    );
}

export default React.memo(SystemRoleFilterPane);